export default __webpack_public_path__ + "static/media/5.6b2a3532.png";